import React from 'react'

import type { NextPage } from 'next'

import { debtPortability } from 'data/seo'
import DebtPortability from 'views/debt-portability'

const DebtPortabilityPage: NextPage = () => <DebtPortability />

export default DebtPortabilityPage

export async function getStaticProps() {
  return {
    props: { SEO: debtPortability }
  }
}
